The response from the `updatePositionProfileFromDraft` mutation.
